module.exports = __webpack_public_path__ + "img/icon-twitter.5fb9507c.svg";